module.exports = __webpack_public_path__ + "static/media/location-arrow.b54a2233.svg";